import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  assetDownload: {
    id: 'asset.download',
    defaultMessage: 'Download',
  },
  assetDownloadError: {
    id: 'asset.download.error',
    defaultMessage: 'Asset download failed.',
  },
  assetCopyUrl: {
    id: 'asset.copyUrl',
    defaultMessage: 'Copy Link',
  },
  assetCopyUrlSuccess: {
    id: 'asset.copyUrl.success',
    defaultMessage: 'Copied!',
  },
  collectionDownload: {
    id: 'collection.download',
    defaultMessage: 'Download Collection',
  },
  menu: {
    id: 'menu',
    defaultMessage: 'More options',
  },
  portalNotFound: {
    id: 'portal.notFound',
    defaultMessage: 'Portal not found',
  },
});
